(function () {
  var body = document.body;
  document.querySelectorAll('[data-menu]').forEach(function (b) {
    b.addEventListener('click', function () {
      var open = body.classList.toggle('menu-open');
      b.setAttribute('aria-expanded', open);
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && body.classList.contains('menu-open')) {
      body.classList.remove('menu-open');
      document.querySelectorAll('[data-menu]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    }
  });
  document.querySelectorAll('[data-autosubmit]').forEach(function (f) {
    f.addEventListener('change', function () { f.submit(); });
  });
  document.querySelectorAll('[data-wa-form]').forEach(function (f) {
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var o = f.elements.order.value.trim(), m = f.elements.email.value.trim();
      var t = 'Hi ' + f.dataset.shop + ', I would like an update on my order ' + o + (m ? ' (email: ' + m + ')' : '') + '.';
      window.open('https://wa.me/' + f.dataset.wa + '?text=' + encodeURIComponent(t), '_blank', 'noopener');
    });
  });
  document.querySelectorAll('[data-parcel-form]').forEach(function (f) {
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      window.open('https://t.17track.net/en#nums=' + encodeURIComponent(f.elements.tn.value.trim()), '_blank', 'noopener');
    });
  });
})();
